import React from "react";
import "./DeliveryBanner.css";
import { useNavigate } from "react-router-dom";
import useWindowDimensions from "../../hooks/useWindowDimensions";
const DeliveryBanner = () => {
  const { width, height } = useWindowDimensions();

  const navigate = useNavigate();
  const handleNav = () => {
    navigate("/contact");
  };

  return (
    <div className={width < 511 ? "delivery-banner-small" : "delivery-banner"}>
      <div className="delivery-banner-overlay ">
        <h2>Free Prescription Delivery!</h2>
        <p>Managing your prescriptions has never been easier.</p>
        <button onClick={handleNav}>Have a question? Contact us</button>
      </div>
    </div>
  );
};

export default DeliveryBanner;
